var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25C5.27625 2.25 2.25 5.27625 2.25 9C2.25 12.7238 5.27625 15.75 9 15.75C12.7238 15.75 15.75 12.7238 15.75 9C15.75 5.27625 12.7238 2.25 9 2.25ZM9 14.625C5.895 14.625 3.375 12.105 3.375 9C3.375 5.895 5.895 3.375 9 3.375C12.105 3.375 14.625 5.895 14.625 9C14.625 12.105 12.105 14.625 9 14.625Z",
    fill: "#2A1B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.7063C8.685 7.7063 8.4375 7.9538 8.4375 8.2688V12.0938C8.4375 12.4088 8.685 12.6563 9 12.6563C9.315 12.6563 9.5625 12.4088 9.5625 12.0938V8.2688C9.5625 7.96505 9.315 7.7063 9 7.7063Z",
    fill: "#2A1B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01125 5.4001C8.71875 5.3776 8.44875 5.68135 8.4375 5.9851C8.4375 5.99635 8.4375 6.06385 8.4375 6.0751C8.4375 6.37885 8.67375 6.60385 8.98875 6.6151H9C9.30375 6.6151 9.55125 6.3451 9.5625 6.0526C9.5625 6.04135 9.5625 5.92885 9.5625 5.92885C9.5625 5.6026 9.32625 5.4001 9.01125 5.4001Z",
    fill: "#2A1B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fedfb96ba49505cf8d3bedb4f2f3d2a4.svg";
export { ForwardRef as ReactComponent };